import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,

  ActivatedRoute
} from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { LoginService } from '../services/login.service';

import { User } from '../models/User';
import { Customer } from '../models/Customer';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user: User;
  customer: Customer;
  userNotFound = false;
  isLoggedIn: boolean;
  resetMsg: string;
  hasResetMsg: boolean;
  orgId: number;
  userId: string;
  ipAddress: string;
  activeAcctId: number;

  // Sets initial value to true to show loading spinner on first load
  loading = true

  //@Output() loginEvent = new EventEmitter<boolean>();

  constructor(
    private service: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.user = {
      username: '',
      password: '',
    };
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })
  }

  ngOnInit() {
    this.isLoggedIn = false;
    this.resetMsg = this.route.snapshot.queryParamMap.get('resetmsg');
    this.hasResetMsg = !!this.resetMsg;

    // Redirect login using sso token if possible
    this.onSSOLoginLoad();

    if (this.service.getIsLoggedIn()) {
      this.service.getUserContext()
        .subscribe((account) => {
          let accountsWithDevices = this.getDefaultAccount(account);
          this.orgId = accountsWithDevices.orgUnitId;
          this.userId = account.UserId;
          //get ipaddress
          this.service.getIpAddress(this.orgId.toString())
            .subscribe((details) => {
              this.ipAddress = details.clientAddress;

              this.isLoggedIn = false;
              //log event
              this.service.userLog(this.userId, this.orgId, "Logout", this.ipAddress).subscribe(
                response => { console.log(response); }
              );
            });
        });
    }

    this.service.clearUserContext();
  }

  getDefaultAccount(account: any){
    let defaultDeviceId = account ? account.defaultDeviceId : 0;
    let accountsWithDevices = account.accountsWithDevices[0];

    if(defaultDeviceId > 0) {
      let accountDevices = account.accountsWithDevices;
      for (let i = 0; i < accountDevices.length; i++) {
        let accountDevice: any = accountDevices[i];
        if(accountDevice.deviceId == defaultDeviceId) {
          accountsWithDevices = accountDevice;
          break;
        }
      }
    }

    return accountsWithDevices;
  }

  onSSOLoginLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const sToken = urlParams.get('stoken');
    const deviceId = parseInt(urlParams.get('deviceId'));
    if(!sToken){
      return;
    }
    this.spinnerService.show();
    this.service.ssoLogin(sToken, deviceId)
      .subscribe((res: any) => {
        if(res && res.success) {
          // Only process successful token transfer
          this.processLoginResult(res, null);
        }
      });
  }

  onLoginClick(uname: string, pass: string) {
    this.spinnerService.show();
    this.user.username = uname;
    this.user.password = pass;
    this.service.login(this.user.username, this.user.password)
      .subscribe((res: any) => {
        this.processLoginResult(res, uname);
      });
  }

  private processLoginResult(res: any, uname: string) {
    if (res.success) {
      this.isLoggedIn = true;

      if (uname && res.needResetPassword) {
        this.router.navigate(['/Login/Reset'], {queryParams: {username: uname, changetype: 1}});
        return;
      }
      let account = res.modelRet;
      let accountsWithDevices = this.getDefaultAccount(account);

      //setting active acctid
      account.activeAcctId = accountsWithDevices.accountId;
      this.service.setUserContextDetail(account);

      //login
      this.service.getUserContext()
        .subscribe((account) => {
          let accountsWithDevices = this.getDefaultAccount(account);
          this.orgId = accountsWithDevices.orgUnitId;
          this.userId = account.UserId;
          //get ipaddress
          this.service.getIpAddress(this.orgId.toString())
            .subscribe((details) => {
              this.ipAddress = details.clientAddress;

              //log event
              this.service.userLog(this.userId, this.orgId, "Login", this.ipAddress).subscribe(
                response => {
                  console.log(response);
                }
              );
            });
        });
      this.router.navigate(['/Billing/Usage']);
    } else {
      this.userNotFound = true;
    }
  }

// Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
      this.spinnerService.show();
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
      this.spinnerService.hide();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
      this.spinnerService.hide();
    }
    if (event instanceof NavigationError) {
      this.loading = false;
      this.spinnerService.hide();
    }
  }
  // TODO: Remove this when we're done
  //get diagnostic() { return JSON.stringify(this.customer); }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts